import { UserType } from "../api"

import UsersListPage from "./UsersListPage"

export default function RegularUsersPage() {
  return (
    <UsersListPage
      userType={UserType.REGULAR}
      title="Regular Users"
      description="Full-access users who can purchase lab tests, receive clinical services, and access all platform features. User type is set automatically based on purchased package, or manually by admins via the user detail page."
      csvPrefix="regular-users"
    />
  )
}
